import { render, staticRenderFns } from "./ValueBuyCard.vue?vue&type=template&id=66e37bed&scoped=true&"
import script from "./ValueBuyCard.vue?vue&type=script&lang=js&"
export * from "./ValueBuyCard.vue?vue&type=script&lang=js&"
import style0 from "./ValueBuyCard.vue?vue&type=style&index=0&id=66e37bed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e37bed",
  null
  
)

export default component.exports